
var sprite = require("/data/src/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"19.595 0.564 454.144 114.145\" id=\"login-talk\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <polygon fill=\"#FFFFFF\" stroke-width=\"2\" stroke-miterlimit=\"10\" points=\"202.125,22.359 202.125,2.885\n\t181.521,22.359 20.595,22.359 20.595,113.709 472.738,113.709 472.738,22.359 \"/> </symbol>";
module.exports = sprite.add(image, "login-talk");


//////////////////
// WEBPACK FOOTER
// ./src/icons/login-talk.svg
// module id = 339
// module chunks = 36